import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { firestore } from '../firebase';
import { SET_RICH_INSIGHTS } from '../store/actions';

export default function useRichInsights() {
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);
  console.log('useRichInsights - account:', account);

  useEffect(() => {
    if (account.initialized && account.active) {
      // Rich Insights (Iniitialize)
      (async () => {
        // Get rich insights for cross persona
        const storeRef = firestore.collection(
          'knowledge_concepts_v0.9'
        );
        console.log('storeRef', account.config.accountId, account.active.id);
        const storeQuery = await storeRef
          .where('account', '==', account.config.accountId)
          .where('client', '==', account.active.id)
          .where('entity.type', '==', 'Store')
          .limit(1)
          .get();

        if (!storeQuery.empty) {
          const storeData = storeQuery.docs[0].data();
          // Process the store data as needed

          console.log('Store entity data:', storeData);

          // Check if we have product affinities
          if (
            storeData
              && storeData.data
              && storeData.data.insights
              && storeData.data.insights.product_affinities
          ) {
            // Dispatch Rich Insights update
            dispatch({
              type: SET_RICH_INSIGHTS,
              payload: storeData.data.insights.product_affinities
            });
          }
        }
      })();
    }
  }, [account, dispatch]);
}
